import { makeStyles } from '@mui/styles';
import { buildVariant } from 'src/utils/mui';

export const useStyles = makeStyles(theme => ({
    closeIcon: {
        cursor: 'pointer',
        position: 'absolute',
        right: 15,
        top: 25,
        ...buildVariant(600, 30, 'textEmphasis')
    },
    dialogTitle: {
        position: 'relative',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        paddingRight: 50,
        maxWidth: '100%',
        padding: '24px 24px 20px',
        ...buildVariant('bold', 24)
    },
    dialogContent: {
        lineHeight: 1.5,
        letterSpacing: 'normal',
        ...buildVariant('normal', 16),
        color: '#4a4a4a'
    },
    dialogActions: {
        width: '100%',
        margin: 0,
        backgroundColor: 'rgba(243, 243, 243, 0.74)',
        padding: '15px 20px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column-reverse'
        }
    }
}));
